import { render } from "./Udp.vue?vue&type=template&id=48637b60&lang=pug"
import script from "./Udp.vue?vue&type=script&lang=js"
export * from "./Udp.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__